import { propertiesTypes } from '@/reports/types';
import { convertNumberToString } from '@/utils/convertNumberToString';

export function formatLocationOfProperty(
  rawProperty: propertiesTypes.Property
) {
  return [
    ['State', rawProperty?.state || '-'],
    ['County', rawProperty?.county || '-'],
    ['City', rawProperty?.parcel_address?.parsed?.city || '-'],
    ['FIPS county code', rawProperty?.fips || '-'],
    ['APN', rawProperty?.apn || '-'],
    ['Duplicate APN', rawProperty?.alternate_apn || '-'],
    ['Brief Description', rawProperty?.legal?.brief_description || '-'],
    ['Subdivision', rawProperty?.legal?.subdivision || '-'],
    ['Tract number', rawProperty?.legal?.tract_number || '-'],
    ['Block', rawProperty?.legal?.block || '-'],
    ['Section', rawProperty?.legal?.section || '-'],
    ['Lot', rawProperty?.legal?.lot_numbers?.[0] || '-'],
    ['Unit', rawProperty?.legal?.unit || '-'],
    [
      'Latitude',
      convertNumberToString(rawProperty?.parcel_address?.geo?.latitude) || '-',
    ],
    [
      'Longitude',
      convertNumberToString(rawProperty?.parcel_address?.geo?.longitude) || '-',
    ],
  ];
}
